export default "__VITE_PUBLIC_ASSET__c7ee4ffa__"